import { CLIENT } from 'core/variables/constant';

/**
 * Clientes que, por decisión de producto, siguen en la interfaz de programa legacy
 * (plantilla Standard legacy + lectura de lesson items por la V2 de la API).
 *
 * GotIt no está aquí a propósito: sus cursos son STEAM y el guard de plantilla de
 * `StandardCourseViewWrapper` (`!isSteam`) los mantiene en el programa legacy (LegacyStandardView),
 * pero la regla es por cliente, no por plantilla, así que GotIt pide la V3 de lesson items.
 */
const LEGACY_PROGRAM_INTERFACE_CLIENTS: ReadonlySet<string> = new Set([CLIENT.TINTA_FRESCA, CLIENT.LIBROS_Y_LIBROS]);

/**
 * Regla única de la interfaz nueva de programa: la usan todos los clientes salvo
 * Tinta Fresca y Libros y Libros.
 *
 * La comparten la UI (`useOrganization` → `tenantConfig.newProgramInterface`) y la capa de
 * datos (`getLessonItemService`, que elige entre la V3 y la V2 de lesson items), para que la
 * vista y el payload que la alimenta no puedan divergir. Salvedad: el override de
 * `third_party_integrations` en `useOrganization.js` puede forzar `newProgramInterface = true`
 * por encima de esta regla (hoy inalcanzable para los dos clientes legacy, ver `useOrganization.test.js`).
 *
 * Con `client` sin resolver devuelve `true`, y es seguro: `TranslationsProvider` pinta `Loading`
 * hasta que `tenant.guid` resuelve, así que ninguna vista llega a consumir ese valor provisional.
 *
 * @param client - Identificador de cliente (`CLIENT.*`) tal y como lo expone
 *                 `organization.selectors.getClient`.
 * @returns `true` si ese cliente usa la interfaz nueva de programa.
 */
export function hasNewProgramInterface(client: string | null | undefined): boolean {
  return !client || !LEGACY_PROGRAM_INTERFACE_CLIENTS.has(client);
}
